

// // import { Link } from "react-router-dom";



// // function FoodandbeveragesSupportSystem() {

// //     const isMobile = window.innerWidth <= 768;

// //     return (
// //         <>
// //             <div className="lg-col-2">
// //             </div>
// //             <div className="lg-col-7">

// //                 <p
// //                     className="breadcrumb maamaas-home-bredcum"
// //                     style={{
// //                         position: "fixed",
// //                         top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// //                         left: "2vw",
// //                         width: "100%",
// //                         backgroundColor: "#fff",
// //                         zIndex: 1000,
// //                         padding: "10px 0",
// //                         fontSize: isMobile ? "16px" : "18px",
// //                         fontWeight: isMobile ? "normal" : "bold",
// //                         textAlign: "center",
// //                         margin: 0,
// //                     }}
// //                 >

// //                     <Link
// //                         to="/foodladingpage"
// //                         style={{
// //                             color: "purple",
// //                             fontWeight: "bold",
// //                             textDecoration: "none",
// //                         }}
// //                     >
// //                         Food & Beverages

// //                     </Link>

// //                     <span className="separator"> &gt; </span>
// //                     <Link

// //                         style={{
// //                             color: "purple",
// //                             fontWeight: "bold",
// //                             textDecoration: "none",
// //                         }}
// //                     >
// //                         Support System
// //                     </Link>
// //                 </p>
// //             </div>
// //             <div className="lg-col-3">
// //             </div>
// //         </>
// //     );
// // }

// // export default FoodandbeveragesSupportSystem;





// // // components/support/SupportSystem.jsx
// // import React, { useState } from 'react';
// // // import RaiseTicket from './RaiseTicket';
// // // import HelpSupportCenter from './HelpSupportCenter';
// // // import LiveChatSupport from './LiveChatSupport';
// // // import FAQKnowledgeBase from './FAQKnowledgeBase';
// // import FoodRaiseTicket from './FoodRaiseTicket';

// // const FoodSupportSystem = () => {
// //   const [activeTab, setActiveTab] = useState('help-center');

// //   // Placeholder components for features not yet implemented
// //   const ComingSoon = ({ featureName }) => (
// //     <div className="coming-soon">
// //       <h3>{featureName} - Coming Soon</h3>
// //       <p>This feature is currently under development and will be available soon.</p>
// //     </div>
// //   );

// //   const tabs = [
// //     // { id: 'help-center', label: 'Help Center', component: <HelpSupportCenter /> },
// //     { id: 'raise-ticket', label: 'Raise a Ticket', component: <FoodRaiseTicket /> },
// //     // { id: 'live-chat', label: 'Live Chat', component: <ComingSoon featureName="Live Chat & Bot Support" /> },
// //     // { id: 'faq', label: 'FAQs', component: <ComingSoon featureName="FAQs & Knowledge Base" /> },
// //   ];

// //   return (
// //     <div className="support-system">
// //       <div className="support-header">
// //         <h1>Support System</h1>
// //         <p>Get help, report issues, or find answers to common questions</p>
// //       </div>

// //       <div className="support-tabs">
// //         {tabs.map((tab) => (
// //           <button
// //             key={tab.id}
// //             className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
// //             onClick={() => setActiveTab(tab.id)}
// //           >
// //             {tab.label}
// //           </button>
// //         ))}
// //       </div>

// //       <div className="support-content">
// //         {tabs.find(tab => tab.id === activeTab)?.component}
// //       </div>
// //     </div>
// //   );
// // };

// // export default FoodSupportSystem;



















// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import HelpSupportCenter from "./HelpSupportCenter";
// import RaiseTicket from "./RaiseTicket";
// // import LiveChat from "./LiveChat";
// import FAQKnowledgeBase from "./FAQKnowledgeBase";

// const FoodSupportSystem = () => {
//     const [activeTab, setActiveTab] = useState("Help & Support");

//     const tabContent = {
//         "Help & Support": <HelpSupportCenter />,
//         "Raise a Ticket": <RaiseTicket />,
//         // "Live Chat": <LiveChat />,
//         "FAQs": <FAQKnowledgeBase />,
//     };
//         const [isMobile, setIsMobile] = useState(false);
    

//     const styles = {
//         container: {
//             height: "100vh",
//             overflowY: "auto",
//             scrollbarWidth: "none"
//         },
//         breadcrumb: {
//             position: "fixed",
//             top: "56px",
//             left: "1vw",
//             width: "100%",
//             backgroundColor: "#fff",
//             padding: "10px 0",
//             fontSize: "18px",
//             fontWeight: "bold",
//             textAlign: "center",
//             margin: 0,
//         },
//         link: {
//             color: "purple",
//             fontWeight: "bold",
//             textDecoration: "none",
//         },
//         tabContainer: {
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             position: "fixed",
//             top: "120px",
//             left: "55%",
//             transform: "translate(-45%, -50%)",
//             gap: "0px",
//             zIndex: 10,
//             width: "100vw",
//             maxWidth: "1200px",
//             flexWrap: "wrap",
//             padding: "10px 0",
//             backgroundColor: "white"
//         },
//         tabButton: {
//             border: "none",
//             borderRadius: "10px",
//             width: "100%",
//             padding: "0 10px",
//             height: "40px",
//             backgroundColor: "#d9d9d9",
//             color: "#000",
//             fontWeight: "bold",
//             cursor: "pointer",
//             transition: "background-color 0.3s ease",
//             fontSize: "0.9rem",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//         },
//         activeTabButton: {
//             backgroundColor: "#b15cd6",
//             color: "#fff",
//         },
//         contentContainer: {
//             height: "95vh",
//             overflowY: "auto",
//             scrollbarWidth: "none",
//             paddingTop: "20px",
//             borderRadius: "8px",
//             marginTop: "110px",
//         }
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10 food-accounts-data-scroll" style={styles.container}>
//                     <p
//                         className="breadcrumb maamaas-home-bredcum"
//                         style={{
//                             position: "fixed",
//                             top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
//                             left: "2vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             zIndex: 1000,
//                             padding: "10px 0",
//                             fontSize: isMobile ? "16px" : "18px",
//                             fontWeight: isMobile ? "normal" : "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >

//                         <Link
//                             to="/fooddashboard"
//                             style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
//                         >
//                             Food & Beverages
//                         </Link>
//                         <span className="separator"> &gt; </span>
//                         <Link

//                             style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
//                         >
//                             Support System
//                         </Link>

//                     </p>
//                     <div className="discount-container accounts-data" >
//                         <div
//                             style={styles.tabContainer}
//                             className="rorr row b2"
//                         >
//                             {Object.keys(tabContent).map((label) => (
//                                 <div
//                                     key={label}
//                                     className="col-lg-3 col-md-6 col-sm-12 col-12"
//                                     style={{
//                                         display: "flex",
//                                         marginBottom: "10px",
//                                         padding: "0 5px",
//                                     }}
//                                 >
//                                     <button
//                                         onClick={() => setActiveTab(label)}
//                                         style={{
//                                             ...styles.tabButton,
//                                             ...(activeTab === label ? styles.activeTabButton : {})
//                                         }}
//                                         title={label}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                         <div
//                             style={styles.contentContainer}
//                             className="b1"
//                         >
//                             {tabContent[activeTab]}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FoodSupportSystem;


import React, { useState } from "react";
import { Link } from "react-router-dom";
import HelpSupportCenter from "./HelpSupportCenter";
import RaiseTicket from "./RaiseTicket";
// import LiveChat from "./LiveChat";
import FAQKnowledgeBase from "./FAQKnowledgeBase";

const FoodSupportSystem = () => {
    const [activeTab, setActiveTab] = useState("Help & Support");
    const isMobile = window.innerWidth <= 768;

    const tabContent = {
        "Help & Support": <HelpSupportCenter />,
        "Raise a Ticket": <RaiseTicket />,
        // "Live Chat": <LiveChat />,
        "FAQs": <FAQKnowledgeBase />,
    };

    // Dynamic height based on screen size
    const containerHeight = window.innerHeight > 600
        ? (
            window.innerWidth < 768
                ? '60vh'
                : window.innerWidth < 850
                    ? '63vh'
                    : window.innerWidth < 1400
                        ? '65vh'
                        : window.innerWidth < 1600
                            ? '70vh'
                            : '75vh'
        )
        : (
            window.innerWidth < 768
                ? '300px'
                : window.innerWidth < 850
                    ? '300px'
                    : window.innerWidth < 1400
                        ? '410px'
                        : window.innerWidth < 1600
                            ? '410px'
                            : '450px'
        );

    return (
        <>
            <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left: 0px;
        }

        @media screen and (max-width: 768px) {
          .tabs-wrapper {
            margin-left: 0;

          }
        }
           @media screen and (min-width: 768px) {
          .tabs-wrapper {
            margin-top: 20px;
            
          }
        }

        .tab-butttons {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 81px;
          padding: 14px;
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: auto;
          min-width:100px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.3s ease;
          font-size: 16px;
          white-space: nowrap;
        }

        .tab-button.active {
          color: white;
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 0px;
          width: 100%;
          overflow-x: auto;
          overflow-y: scroll;
        }

        .tab-content::-webkit-scrollbar {
          width: 1px;
          height: 8px;
        }

        .tab-content::-webkit-scrollbar-track {
          background: #f0f0f0;
        }

        .tab-content::-webkit-scrollbar-thumb {
          background: #b15cd6;
          border-radius: 10px;
        }

        .tab-content {
          scrollbar-width: none;
        }

        .support-mobilescroll {
          margin-top: 119px !important;
        }

        @media (min-width: 768px) {
          .support-mobilescroll {
            width: 62vw !important;
            margin-left: -1vw !important;
          }
        }

        @media (max-width: 500px) {
          .tab-button {
            // width: 160px !important;
            font-size: 13px;
          }
        }

        @media (max-width: 400px) {
          .tab-button {
            // width: 140px !important;
            font-size: 12px;
          }
        }

        @media (min-height:800px) {
          .company-mobile-data {
            height: 92vh !important;
          }
          .tab-content {
            height: 70vh !important;
          }
        }

        @media (min-height:600px) and (max-height:800px) {
          .tab-content {
            height: 65vh !important;
          }
        }
          @media(min-height:500px){
          .container-fluid{
          height:100vh !important;
          }
          }
           @media(max-height:500px){
          .container-fluid{
          height:70vh !important;
          }
          }
          
      `}</style>

            <div className="container-fluid company-mobile-data"
                style={{
                    height: window.innerHeight<500 ? "100vh" : "70vh",
                    backgroundColor:"white"
                }}
            >
                <div className="row" style={{backgroundColor:"white"}}>
                    {/* Left Column - Empty */}
                    <div className="col-lg-2">
                        {/* Left section completely empty as requested */}
                    </div>

                    {/* Middle Column - Main Content */}
                    <div className="col-lg-10">
                        {/* Breadcrumb */}
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 500 ? "50px" : window.innerWidth > 500 && window.innerWidth <= 768 ? "55px" : "64px",
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/foodladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Support System
                            </Link>
                        </p>

                        {/* Main Content Container */}
                        <div style={{
                            marginTop: window.innerWidth < 768 ? "0px" : "00px",
                            padding: isMobile ? "15px" : "20px",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            width: window.innerWidth < 700 ? "94vw" : "auto",
                        }}>
                            {/* Tabs Wrapper */}
                            <div className="tabs-wrapper" style={{marginTop:window.innerWidth<500 ? "0px":" "}}>
                                {/* Tab Buttons - Matching your Foodbeveragescompany structure */}
                                <div className="tab-butttons" style={{
                                    flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap",
                                    marginTop: window.innerWidth<769 ? "00px" : "50px",
                                    paddingLeft:window.innerWidth<500 ? "0px" :" ",
                                    paddingRight:window.innerHeight<500 ? "25px":" ",
                                    marginRight:window.innerWidth<769 ? " " : " 20%"
                                }}>
                                    {Object.keys(tabContent).map((label) => (
                                        <button
                                            key={label}
                                            className={`tab-button ${activeTab === label ? "active" : ""}`}
                                            onClick={() => setActiveTab(label)}
                                        >
                                            {label}
                                        </button>
                                    ))}
                                </div>

                                {/* Tab Content */}
                                <div
                                    className="tab-content"
                                    style={{
                                        height: containerHeight,
                                        overflowX: "auto",
                                        overflowY: "scroll",
                                        width:  window.innerWidth < 450 ? "90vw" : " ",
                                        padding: "10px",
                                        backgroundColor: "#fff",
                                        borderRadius: "8px",
                                    }}
                                >
                                    {tabContent[activeTab]}
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>
        </>
    );
};

export default FoodSupportSystem;